import { BorrowerOnboardingDetails, CardId, NationalityPeriod } from '@nemuru-eng/js-api-client';

import { NieDataFormType } from '@/components/modules/KYC/KYCLoan/BorrowerKYC/components/DocumentIdSection/schemas/nieDataForm.schema';

export const NIE_DATA_FORM_BLANK_VALUES: Partial<NieDataFormType> = {
  nationalityPeriod: NationalityPeriod.UNKNOWN,
  cardId: CardId.INITIAL,
  expirationDateCard: new Date('2035-01-03'),
  socialSecurityDate: new Date('2023-03-19'),
  numberOfWork: 2,
};

export const mapNieDataToFormValues = (
  nieData: NonNullable<BorrowerOnboardingDetails['nieData']>,
): NieDataFormType => ({
  nationalityPeriod: nieData.nationalityPeriod,
  cardId: nieData.cardId,
  expirationDateCard: new Date(nieData.expirationDateCard),
  socialSecurityDate: new Date(nieData.socialSecurityDate),
  numberOfWork: nieData.numberOfWork,
});
